import React from 'react'
import Button from './buttonRounded'
import {ReactComponent as People} from '../../assets/svg/ico_people.svg'
import {ReactComponent as Filter} from '../../assets/svg/ico_filter.svg'
import {ReactComponent as Search} from '../../assets/svg/ico_search.svg'

const ActionsBar = ({
  lang,
  toggleLang,
  toggleFilters,
  filtersActive,
  showFilterIndicator,
  toggleSearch,
  searchActive,
  toggleCredits,
  creditsActive
}) => (
  <div className="App-actions-bar">
    <Button label={lang} action={toggleLang} />
    <Button SvgIcon={People} action={toggleCredits} isActive={creditsActive} />
    <Button SvgIcon={Filter} action={toggleFilters} isActive={filtersActive} showIndicator={showFilterIndicator}/>
    <Button SvgIcon={Search} action={toggleSearch} isActive={searchActive} />
  </div>
)

export default ActionsBar